'use client'

import { getLogger } from '@logtape/logtape'
import { Destination } from '@server/schemas'
import { env } from '@shared/config/env'

const logger = getLogger(['web', 'auth', 'client-action'])

// 로컬스토리지 인증 관련 상수
export const AUTH_STORAGE_KEY = 'podo_auth_data'

export const clearLegacyAuthStorage = () => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    localStorage.removeItem(AUTH_STORAGE_KEY)
    return true
  } catch (error) {
    logger.warn('clear-legacy-auth-localstorage-failed', { error })
    return false
  }
}

// 인증 상태 검증 및 리다이렉트 URL 생성 로직
export const getRedirectUrl = async (
  destination: Destination,
): Promise<{
  url: string
  reason:
    | 'redirect-to-login-page-because-no-auth-available'
    | 'redirect-to-temp-url-because-submitting-period-feature-flag'
    | 'redirect-to-login-page-because-not-authorized-user'
    | 'redirect-to-gateway-page'
}> => {
  clearLegacyAuthStorage()

  const callbackRedirectGatewayUrl = new URL('/callback/oauth/redirect', env.NEXT_PUBLIC_API_URL)
  callbackRedirectGatewayUrl.searchParams.set('destination', destination)

  // 게이트웨이 URL 생성
  return {
    url: callbackRedirectGatewayUrl.toString(),
    reason: 'redirect-to-gateway-page',
  }
}
